<template>
	<layout-main>
		<template #toolbar>
			<layout-tool-bar :title="title" />
		</template>

		<v-container class="fill-wh">
			<router-view />
		</v-container>

		<template #footer>
			<layout-footer @click:tab="navigate" />
		</template>
	</layout-main>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

export default {
	data: () => ({
		strings: strings.live,
	}),

	computed: {
		contextType() {
			if (this.$route.params.userId) return "User";
			else if (this.$route.params.systemId) return "System";
			else if (this.$route.params.communityId) return "Community";

			return null;
		},

		title() {
			const key = (this.contextType || "").toLowerCase();
			const title = _.get(
				this.strings.titles,
				key,
				this.strings.titles.default
			);
			return title;
		},
	},

	methods: {
		navigate(to) {
			const communityId = this.$store.state.session.communityId;

			if (to === "community") {
				return this.$root.$router.push({
					path: "/live",
					query: { force: true },
				});
			} else if (to === "room" && communityId) {
				return this.$root.$router.push(`/live/${communityId}/system`);
			}
		},
	},
};
</script>
